import { render, staticRenderFns } from "./co-broker-confirmation-step.vue?vue&type=template&id=40121119&scoped=true"
import script from "./co-broker-confirmation-step.vue?vue&type=script&lang=js"
export * from "./co-broker-confirmation-step.vue?vue&type=script&lang=js"
import style0 from "./co-broker-confirmation-step.vue?vue&type=style&index=0&id=40121119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40121119",
  null
  
)

export default component.exports